import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';

import * as React from 'react';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useUtxEarnSubscriptionsGetSubscriptionDetail } from '@utx/utx-client';
import { AutoRenewal } from '../../components/autoRenewal/AutoRenewal.web';
import { EarnStackRoutes, EarnStackScreenProps } from '../../earn.navigator';
import { RedeemNavigator } from '../redemption/redemption.navigator';
import { ModalContainerView } from '../subscription/ModalContainerView';
import { SubscriptionDetails } from './subscriptionDetails.modal.web';
import { SubscriptionDetailsStackParamList, SubscriptionDetailsStackRoutes } from './type';

const SubscriptionDetailsStack = createNativeStackNavigator<SubscriptionDetailsStackParamList>();

export const SubscriptionDetailsNavigator: React.FC<EarnStackScreenProps<EarnStackRoutes.SubscriptionDetails>> = ({ route }) => {
  const { subscription, onUpdate, refreshPortfolio } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  return (
    <ModalContainerView dimensions={dimensions}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <SubscriptionDetailsStack.Navigator
          initialRouteName={SubscriptionDetailsStackRoutes.Main}
          screenOptions={{
            presentation: 'modal',
            headerShown: false,
            contentStyle: {
              backgroundColor: 'transparent'
            }
          }}>
          <SubscriptionDetailsStack.Screen
            name={SubscriptionDetailsStackRoutes.Main}
            component={SubscriptionDetails}
            initialParams={{ subscription, onLayout, onUpdate }}
            options={{ headerShown: false }}
          />
          <SubscriptionDetailsStack.Screen
            name={SubscriptionDetailsStackRoutes.AutoRenew}
            component={AutoRenewal}
            options={{ presentation: layout.isMobile ? 'transparentModal' : 'modal', headerShown: false }}
          />
          <SubscriptionDetailsStack.Screen
            name={SubscriptionDetailsStackRoutes.Redeem}
            component={RedeemNavigator}
            options={{
              headerShown: false,
              presentation: layout.isMobile ? 'transparentModal' : 'modal'
            }}
            initialParams={{ subscription, onLayout, onUpdate, refreshPortfolio }}
          />
        </SubscriptionDetailsStack.Navigator>
      </View>
    </ModalContainerView>
  );
};
